import { useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import CommonDatePicker from "../../common/inputs/CommonDatePicker";
import { LuPlane } from "react-icons/lu";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import updateTask from "../../../controllers/Tasks/updateTask";
import { enqueueSnackbar } from "notistack";
import getAdminTeamMembers from "../../../controllers/settings/adminTeam/getTeamMembers";
import getTask from "../../../controllers/Tasks/getTask";
import {
  getBookingId,
  getOrderManagementId,
  getTaskFieldName,
  openTaskRoute,
  timeAgo,
} from "../../../utils/task/taskUtilFun";
import moment from "moment";
import useAccount from "../../../hooks/useAccount";
// import { getBookingId, getOrderManagementId, timeAgo } from "./taskUtilFun";

const ViewTaskModal = ({ data, open, onClose, setAffect, type }) => {
  const [selectedUser, setSelectedUser] = useState("");
  const { checkPermission } = useAccount();
  const [staffs, setStaffs] = useState([]);
  const [taskDetails, setTaskDetails] = useState({});
  const [loadings, setLoadings] = useState({
    fetchDetails: false,
    fetchStaff: false,
    submit: false,
  });
  const [formData, setFormData] = useState({
    handler: "assign",
    assignee: "",
    note: data?.note || "",
    priority: "Medium",
    dueDate: data?.dueDate ?? new Date(),
  });

  const orderManagementId = getOrderManagementId(data);
  const fieldName = getTaskFieldName(data?.taskType);

  console.log("Task Data:", data);
  async function loadStaff() {
    setLoadings({ ...(loadings || {}), fetchStaff: true });
    const res = await getAdminTeamMembers();
    setLoadings({ ...(loadings || {}), fetchStaff: false });
    if (res.return) {
      setStaffs(res?.data?.data || []);
    }
  }

  const loadTaskDetail = async () => {
    setLoadings({ ...loadings, fetchDetails: true });
    console.log("loadTaskDetail..........................");
    const res = await getTask(data?._id);
    if (res.return) {
      setTaskDetails(res?.data || {});
      setLoadings({ ...loadings, fetchDetails: false });
    } else {
      enqueueSnackbar(res.msg, { variant: "error" });
      setLoadings({ ...loadings, fetchDetails: false });
    }
  };

  useEffect(() => {
    loadTaskDetail();
    if (data) {
      loadStaff();
    }
  }, []);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    console.log("Assigned Task Data:", formData);
    const payload = {
      note: formData.note,
      taskType: data?.taskType,
      priority: formData.priority,
      assignee: assignedUser?._id,
      [fieldName]: orderManagementId,
      dueDate: formData.dueDate
        ? moment(formData.dueDate).format("YYYY-MM-DD")
        : "",
    };

    console.log("Payload:", payload);
    setLoadings({ ...loadings, submit: true });
    const res = await updateTask(data?._id, payload);
    if (res.return) {
      enqueueSnackbar("Task has been updated successfully.", {
        variant: "success",
      });
      setFormData({
        note: "",
        priority: "Medium",
        dueDate: "",
        assignee: "",
        handler: "assign",
      });
      setAffect((prev) => prev + 1);
      setLoadings({ ...loadings, submit: false });
    } else {
      enqueueSnackbar(res.msg, { variant: "error" });
      setLoadings({ ...loadings, submit: false });
    }
    setLoadings({ ...loadings, submit: false });

    onClose();
  };

  const assignedUser = staffs.find((user) => user._id === data?.assignee);
  const canReAssign = checkPermission("update:assign-agent");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div
        className={`w-full max-w-3xl ${
          type === "ViewTask" ? "max-h-[90vh]" : "h-[50vh]"
        }  flex flex-col rounded-lg bg-white shadow-lg`}
      >
        {/* Header */}
        <div className="flex items-center justify-between rounded-t-lg bg-blue-600 px-4 py-5 shrink-0">
          <h2 className="text-lg font-medium text-white">
            {type === "ReAssignTask" ? "Update Assign Task" : "View Task"}{" "}
          </h2>
          <button
            onClick={onClose}
            className="rounded p-1 text-white hover:bg-white/20"
          >
            <IoMdClose size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto space-y-4 p-10">
          {type === "ViewTask" && taskDetails && (
            <>
              <div className="border border-gray-200 rounded-lg p-6 flex flex-col space-y-4 shadow-sm">
                <div className="flex justify-between">
                  <div className="flex space-x-3 items-center">
                    <LuPlane className="text-blue-500" />
                    <h5>Task Details</h5>
                  </div>

                  <div
                    onClick={() => openTaskRoute("ViewRequest", data)}
                    className="hover:underline text-lg cursor-pointer"
                  >
                    <span className="font-medium text-primary1">
                      View Request
                    </span>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-6">
                  <div className="flex flex-col justify-start space-y-2">
                    {/* <span className="text-gray-400">Agent Name</span> */}
                    <span className="text-gray-400">Task priority</span>
                    <span className="text-black">{data?.priority}</span>
                  </div>
                  <div className="flex flex-col justify-start space-y-2">
                    <span className="text-gray-400">Task updatedAt</span>
                    {/* <span className="text-gray-400">Old Date</span> */}
                    <span className="text-black">
                      {timeAgo(data?.updatedAt)}
                    </span>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-6">
                  <div className="flex flex-col justify-start space-y-2">
                    <span className="text-gray-400">Booking Reference</span>
                    <span className="text-black">
                      {getBookingId(data) || "---"}
                    </span>
                  </div>
                  <div className="flex flex-col justify-start space-y-2">
                    <span className="text-gray-400">task createdAt</span>
                    <span className="text-black">
                      {" "}
                      {timeAgo(data?.createdAt)}
                    </span>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-6">
                  {/* <div className="flex flex-col justify-start space-y-2">
                    <span className="text-gray-400">Passenger(s)</span>
                    <span className="text-black">
                      {taskDetails?.changeOrderManagement?.passengerInfo
                        ?.map(
                          (p) =>
                            `${
                              p.firstName.charAt(0).toUpperCase() +
                              p.firstName.slice(1)
                            } ${
                              p.lastName.charAt(0).toUpperCase() +
                              p.lastName.slice(1)
                            }`
                        )
                        .join(", ")}
                    </span>
                  </div> */}
                  {/* <div className="flex flex-col justify-start space-y-2">
                    <span className="text-gray-400">Supplier</span>
                    <span className="text-black">British Airways</span>
                  </div> */}
                </div>
                <div className="grid grid-cols-2 gap-6">
                  {/* <div className="flex flex-col justify-start space-y-2">
                    <span className="text-gray-400">Route</span>
                    <span className="text-black">
                      Lagos (LOS) → London (LHR)
                    </span>
                  </div> */}
                </div>
              </div>

              <div className="border border-gray-200 rounded-lg p-6 flex flex-col space-y-4 shadow-sm">
                <h5>Remarks</h5>
                <span className="text-[#0A0A0A]">{data?.note || "---"}</span>
              </div>
            </>
          )}

          {/* Handler */}
          {canReAssign && (
            <>
              <RadioGroup
                name="handler"
                value={formData.handler}
                onChange={handleChange}
                row
                sx={{ width: "100%" }}
              >
                {/* <FormControlLabel
              value="direct"
              control={<Radio />}
              label="Handle By Supplier"
            /> */}
                <FormControlLabel
                  value="assign"
                  control={<Radio />}
                  label="Assign To a Team"
                />
              </RadioGroup>

              {formData.handler === "assign" && (
                <div className="grid grid-cols-2 gap-3">
                  <div className="flex flex-col space-y-2">
                    <p>Priority</p>
                    <select
                      name="priority"
                      value={formData.priority || data?.priority}
                      onChange={handleChange}
                      className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none"
                    >
                      <option value="Low">Low</option>
                      <option value="Medium">Medium</option>
                      <option value="High">High</option>
                      <option value="Urgent">Urgent</option>
                    </select>
                  </div>

                  <CommonDatePicker
                    label="Due Date"
                    value={formData.dueDate}
                    minDate={new Date()}
                    onChange={(date) =>
                      setFormData({ ...formData, dueDate: date })
                    }
                  />
                </div>
              )}

              {/* Note */}
              <textarea
                name="note"
                rows={4}
                placeholder="Add note"
                value={formData.note || data?.note}
                onChange={handleChange}
                className="w-full resize-none rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none"
              />

              {/* Assignee */}
              {formData.handler === "assign" && (
                <div className="flex flex-col space-y-2">
                  <label
                    htmlFor="assignee"
                    className="text-sm font-medium text-gray-700"
                  >
                    Assignee
                  </label>
                  <select
                    id="assignee"
                    name="assignee"
                    value={formData.assignee || assignedUser?._id}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      // assignedst selectedUser = staffs.find(
                      //   (user) => user._id === data?.assignee
                      // );
                      // assignedf (selectedUser) {
                      //   assigneder(selectedUser);
                      // }
                      setSelectedUser(selectedId);
                      handleChange(e);
                    }}
                    className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none"
                  >
                    <option value="">Select Staff</option>
                    {staffs.map((user) => (
                      <option key={user._id} value={user._id}>
                        {user.firstName} {user.lastName}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            </>
          )}
        </div>

        {/* Footer */}
        {canReAssign && (
          <div className="flex justify-between gap-3 border-t px-10 py-10 shrink-0">
            <button
              className="rounded-md border border-blue-600 px-16 py-3 text-base font-medium text-blue-600 hover:bg-blue-50"
              onClick={() => console.log("Send to supplier", formData)}
            >
              Send to supplier
            </button>

            <button
              onClick={handleSubmit}
              loading={loadings.submit}
              disabled={loadings.submit}
              className="rounded-md bg-blue-600 px-16 py-3 text-base font-medium text-white hover:bg-blue-700"
            >
              {loadings.submit ? "Assigning..." : "Update task"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewTaskModal;
